<template>
  <div v-if="company">
    <div v-if="loadedCompany.notInterestedOtherAdvisor">
    Client in Contract with {{loadedCompany.notInterestedOtherAdvisor}}  till {{getDateNoTime(loadedCompany.notInterestedOtherAdvisorContractEndDate)}} 
    </div>
    <SubHeader title="Notes" />

    <b-button
      class="add-finance"
      variant="primary"
      type="button"
      @click="addNote()"
      ><font-awesome-icon icon="plus" />&nbsp;Add Note
    </b-button>

    <b-row class="my-1">
      <b-col md="3" class="label">
        <label for="selectedSystem">System</label>
      </b-col>
      <b-col md="6">
        <b-form-select
          id="selectedSystem"
          v-model="selectedSystem"
          :options="systemTypes"
        ></b-form-select>
      </b-col>
    </b-row>

    <b-table
      v-if="noteItems"
      :items="noteItems"
      :fields="fields"
      class="table"
      :responsive="true"
    >
      <template v-slot:cell(note)="data">
        {{ data.item.notes }}
      </template>

      <template v-slot:cell(type)="data">
        {{ data.item.companyNoteTypeName }}
      </template>

      <template v-slot:cell(date)="data">
        {{ getDate(data.item.createdDatetime) }}<br />
        <span v-if="data.item.createdUser">{{
          data.item.createdUser.fullName
        }}</span>
      </template>
    </b-table>
    <CompanyNotesModal ref="companyNotesModal" :system-id="selectedSystem" :company-id="$props.company.id" />
  </div>
</template>


<script>
import SubHeader from "@/components/shared/SubHeader.vue";
import CompanyNotesModal from "@/components/company/notes/CompanyNotesModal.vue";
import { format } from "date-fns";

export default {
  components: { SubHeader, CompanyNotesModal },
  props: {
    company: Object,
  },
  data() {
    return {
      loadedCompany: this.company,

      systemTypes: [
        { text: "One80", value: 2 },
        { text: "Globe", value: 1 },
        { text: "randd", value: 3 },
        { text: "Pinnacle", value: 4 },
      ],
      selectedViewType: 1,
      selectedCategory: "All History",
      selectedSystem: 3,
      fields: [
        { key: "note", label: "Notes", sortable: false },
        { key: "type", label: "Type", sortable: false },
        { key: "date", label: "Date/User", sortable: false },
      ],
      notes: []
    };
  },
  computed: {
    noteItems: function () {
      if (!this.company) return [];

      return this.company.companyNotes.filter(
        (x) => x.systemId == this.selectedSystem
      );
    },
  },
  mounted() {
    this.$root.$on('bv::modal::hide', (modalId) => {
      if (modalId == 'NOTES') {
        this.loadNotes();
      }
    })
  },
  methods: {
    getDateNoTime(date) {
      return format(new Date(date), "dd/MM/yyyy");
    },
    getDate(date) {
      return format(new Date(date), "dd/MM/yyyy HH:mm");
    },
    addNote() {
      this.$refs.companyNotesModal.showModal()
    },
    loadNotes() {
      this.$http.get('company/' + this.$props.company.id).then((response) => {
        this.company.companyNotes = response.data.companyNotes;
      })
    },

  },
};
</script>


<style scoped>
.table {
  font-size: 0.85em;
}

.label {
  text-align: right;
}
.label > label {
  margin-top: 6px;
}
</style>

